import React, { useCallback, useState, useMemo } from 'react';
import _ from 'lodash';
// TODO: move to SelectV2
import Selector from '../Selector/Selector';


/**
 *
 * @param {array} items
 * @param {function(selected)}  onSelect
 *
 * @returns GraphTreeChooser
 */
const TreeSelector = ({ treeRoots, initialRoot, isLoading, onSelect, props }) => {
  const [selectedItem, setSelectedItem] = useState('');

  const treeRootItems = useMemo(() => {

    const roots = treeRoots.map(root => (root.id === initialRoot) ? { ...root, isSelected: true, name: root.displayName } : { ...root, name: root.displayName });
    const selected = _.find(roots, { id: initialRoot }) ?? roots[0];
    setSelectedItem(selected);
    return roots;
  }, [initialRoot, treeRoots]);

  const _onSelect = useCallback((items) => {
    setSelectedItem(items[0]);
    if (!_.isEmpty(items[0])) {
      onSelect?.(items[0].id);
    }
  }, [onSelect]);

  // TODO: Use Select component instead.
  return (
    <Selector
      items={treeRootItems}
      onSelect={_onSelect}
      isLoading={isLoading}
      selectedItem={selectedItem?.displayName}
      {...props}
    />
  );

};

export default React.memo(TreeSelector);
